import React, { useContext, useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import { SessionContext } from '../../common/SessionContext';

function JobsDetailsTab(props) {

    return (
        <div
            className="tab-pane fade show active package-info-tab"
            id="pill-body1"
            role="tabpanel"
            aria-labelledby="pills-package1"
        >
            <div className="workshop_bodytext">
                
                There are currently no open positions. Our team is growing all the time, please check back frequently.

            </div>

        </div>
    );
}

export default JobsDetailsTab;
